module.exports = __webpack_public_path__ + "static/media/sopt15ru.0d36e1cc.pdf";